export default {
	"daa1353d65dafad624b1a415c2b3d5ff": "Are you sure you want to delete this address",
	"9f2d441c5f6016b94332c4e1024c4a32": "Cancel",
	"73b7dcaaff05d3974ca1b8bf11cf873e": "Confirm"
}
